/*
 * @Description: 
 * @Author: kai.zhou
 * @Date: 2020-11-13 21:14:19
 * @LastEditors: kai.zhou
 * @LastEditTime: 2020-12-07 18:03:21
 */
export default {
  lang: "法语",
  common: {
    name1: "Créer une carte",
    name2: "Liste de classement",
    name3: "Partager et obtenez des j'aimes",
    name4: "Vous avez obtenu XX j'aimes",
    name5: "Vous êtes le top x maintenant, continuez!",
    name6: "Obtenez plus de j'aimes",
    name7: "Soumettre vos informations",
    name8: "Nom et prénom",
    name9: "Téléphone",
    name10: "Pays",
    name11: "Enregistrez",
    name12: "Moins de 100 mots",
    name13:"Écrivez d'abord votre propre bénédiction",
    name14:"limité à 230 caractères",
    name15:"N'oubliez pas de soumettre vos informations pour gagner les cadeaux",
    name16:"1.Ecrivez des Salutations à vos amis,Partagez-les à vos amis et obtenez des j’aimes",
    name17:"2.Si vous obtenez plus de j’aimes, vous gagnerez l'iPhone 12 mini~",
    name18:"3.If vous êtes dans le TOP 100, you vous obtiendrez également un cadeau.",
    name19:"Noël – Moment propice pour gagner un iPhone",
    name20:"Choisissez une carte que vous aimez",
    name21:"Titre",
    name22:"Astuce",
  },
  rules: {
    name1: "Phone 12 Mini",
    name2: "Cartes de recharge",
    name3: "1 Go",
    name4: "100 Mo",
    name5: "Cadeaux",
    name6: "Comment participer:",
    name7: "1.Choisissez une carte que vous aimez et écrivez vos salutations dessus ",
    name8: "2.Partagez la carte avec vos amis pour qu'ils les aime.",
    name9: "3.Celui qui obtiendra le plus de j’aimes gagnera un iPhone 12 Mini.",
    name10: "4.Si vous êtes dans le TOP 100, vous obtiendrez également un cadeau.",
    name11: "Liste de classement",
    name12: "Liste des cadeaux",
    name13:"TOP1",
    name14:"iPhone 12 Mini（64G）",
    name15:"Top 2 à Top 10",
    name16:"Cartes de recharge",
    name17:"Top 11 à Top 50",
    name18:"1 Go",
    name19:"Top 51 à Top 100",
    name20:"100 Mo",
    name21:"Note:",
    name22:"1.Uniquement ceux qui ont des comptes Carlcare peuvent participer, si vous n'en avez pas, veuillez d’abord créer un.",
    name23:"2.Si vous gagnez des cadeaux, veuillez soumettre vos informations pendant la période d'activité, sinon, les cadeaux seront annulés.",
    name24:"3.Si vous avez des problèmes, contactez-nous : carlcarelucky@gmail.com",
    name25:"4.Carlcare se réserve le droit d'interprétation final",
    name26:"Joyeux Noël Bénissez pour gagner iPhone",
    name27:"Joyeux Noël",
    name28:"Règle d'activité",
    name29:"OK",
    name30:"Mis à jour",
    name31:"Mettez à jour pour participer au activité",
    name32:"S'identifier",
    name33:"Connectez-vous d'abord，s'il vous plait.",
    name34:" PARTIE TERMINÉE",
    name35:"Vous avez gagné",
    name36:"J'aime",
    name37:"Avec mes souhaits",
    name38:"Obtenir",
    name39:"Rang",
    name40:"ID",
    name41:"Règles",
    name42:"Vous êtes le top",
    name43:"maintenant, continuez!",
    name44:"Carte ",
    name45:"Veuillez remplir les informations complètes ",
    name46:'Vous avez soumis les informations avec succès ',
    name47:"Joyeux Noël-Obtenez J'aime pour gagner l'iPhone 12",
  },
};